import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import i18n from './plugins/i18n.js'
import './plugins/clipboard.js'
import '@/icons' // icon
import '@/styles/index.scss' // global css
import '@/permission' // permission control
import '@/utils/get-common-data'
import '@/utils/instructions'
import '@/utils/thousandthPercentile'
Vue.config.productionTip = false


new Vue({
    i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
